<template>
    <v-ons-page id="app">
        <v-ons-splitter>
            <v-ons-splitter-content>
                <v-ons-navigator :page-stack="pageStack">
                    <v-ons-page :key="$route.path" class="main">
                        <header-component
                            v-show="metadata.showMenu"
                            v-bind="metadata"
                            :pageStack="pageStack"
                            @back="popPageStack"
                            ></header-component>
                        <router-view
                            @init="updateMetadata"
                            @logout="logout"
                            ></router-view>
                        <footer-component
                            v-show="metadata.showFooter"
                            v-bind="metadata"
                            ></footer-component>
                    </v-ons-page>
                </v-ons-navigator>
            </v-ons-splitter-content>

            <v-ons-splitter-side v-show="metadata.showMenu"
                :open.sync="menuIsOpen"
                swipeable
                collapse
                animation="overlay"
                width="250px"
                side="right">
                <menu-component
                    v-if="metadata.showMenu"
                    @logout="logout"
                    @change="toggleMenu(0)"
                    ></menu-component>
            </v-ons-splitter-side>

            <notification-component></notification-component>
        </v-ons-splitter>
    </v-ons-page>
</template>

<script>
import MenuComponent from './components/partials/Menu'
import HeaderComponent from './components/partials/Header'
import FooterComponent from './components/partials/Footer'
import NotificationComponent from './components/partials/Notification'

export default {
    name: 'app',

    data() {
        return {
            pageStack: [],
            metadata: {
                name: null,
                title: null,
                path: null,
                showMenu: false,
                showFooter: false,
            }
        }
    },

    components: {
        MenuComponent,
        HeaderComponent,
        FooterComponent,
        NotificationComponent,
    },

    created() {
        window.addEventListener('notification', (e) => {
            let message = e.detail

            if (_.get(message, 'route')) {
                window._redirectRoute = message.route
                this.$router.push(message.route)
            }
        })
    },

    computed: {
        menuIsOpen: {
            get () {
                return this.$store.state.splitter.open
            },

            set (newValue) {
                this.$store.commit('splitter/toggle', newValue)
            }
        },
    },

    methods: {
        updateMetadata(metadata) {
            let push = true;

            if (!this.metadata.showMenu) {
                push = false
            }

            if (!this.metadata.path) {
                push = false
            }

            if (this.metadata.path === this.$route.path) {
                push = false
            }

            if (this.metadata.name == 'login') {
                push = false
                this.pageStack = []
            }

            if (push) {
                this.pageStack.push(this.metadata)
            }

            this.metadata = _.assign({ path: this.$route.path }, metadata)
            // this.$store.commit('history/push', this.metadata)
        },

        popPageStack(page) {
            let previousPage = this.pageStack.pop()
            this.metadata.path = null // set this so that it would not pushed to pagStack
            this.$router.push(previousPage.path)
        },

        toggleMenu(newValue) {
            this.$store.commit('splitter/toggle', newValue)
        },

        logout() {
            window.localStorage.removeItem('login')
            this.pageStack = []
            this.$router.push({ name: 'login' })
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/App.vue